import { styled } from '@mui/material/styles';

// PFM-2641: `fullWidth` is set in a hashed share-link view, where the edition's
// document-list sidebar (300px, see DocumentList.styles StyledSidebar) is not
// rendered — the document takes the whole row instead of floating beside it.
export const StyledContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})(({ theme, fullWidth }) => ({
  width: fullWidth ? '100%' : 'calc(100% - 300px)',
  height: 'calc(100dvh - 64px)',
  float: fullWidth ? 'none' : 'right',
  overflowY: 'auto',
  [theme.breakpoints.down('lg')]: {
    width: '100%',
    float: 'none',
    position: 'relative',
    overflowY: 'initial',
  },
  '@media print': {
    height: 'inherit',
  },
}));
